import type { ProductGetResult } from "@/dao/product";

export const findSelectedVariant = (
	variants: ProductGetResult["variants"],
	searchParams: Record<string, string | undefined>,
) => {
	return variants.find((v) => {
		return v.combinations.every((c) => {
			const { label } = c.variantValue.variantType;
			const { value } = c.variantValue;
			return searchParams[label] === value;
		});
	});
};
